/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Why_YouInputs */

const en_us2_profile_why_you = /** @type {(inputs: Profile_Why_YouInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Age, sex and height tune the load and energy estimates.`)
};

const pt_br2_profile_why_you = /** @type {(inputs: Profile_Why_YouInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Idade, sexo e altura ajustam as estimativas de carga e de gasto de energia.`)
};

const es_419_profile_why_you = /** @type {(inputs: Profile_Why_YouInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La edad, el sexo y la estatura ajustan las estimaciones de carga y de gasto de energía.`)
};

const pt_pt2_profile_why_you = /** @type {(inputs: Profile_Why_YouInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Idade, sexo e altura ajustam as estimativas de carga e de gasto de energia.`)
};

const fr_fr2_profile_why_you = /** @type {(inputs: Profile_Why_YouInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'âge, le sexe et la taille affinent les estimations de charge et de dépense d'énergie.`)
};

const de_de2_profile_why_you = /** @type {(inputs: Profile_Why_YouInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alter, Geschlecht und Größe verfeinern die Schätzungen für Gewicht und Energieverbrauch.`)
};

const it_it2_profile_why_you = /** @type {(inputs: Profile_Why_YouInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Età, sesso e altezza regolano le stime di carico e di energia.`)
};

/**
* | output |
* | --- |
* | "Age, sex and height tune the load and energy estimates." |
*
* @param {Profile_Why_YouInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_why_you = /** @type {((inputs?: Profile_Why_YouInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Why_YouInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_why_you(inputs)
	if (locale === "es-419") return es_419_profile_why_you(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_why_you(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_why_you(inputs)
	if (locale === "de-DE") return de_de2_profile_why_you(inputs)
	if (locale === "it-IT") return it_it2_profile_why_you(inputs)
	return en_us2_profile_why_you(inputs)
});
export { profile_why_you as "profile.why_you" }